import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const TrackKBlue = ({ state, workState, onLabelClick }) => (
	<g id="TrackKBlue" transform="translate(1860.000000, 1058.000000)" className="track">
		<path
			d="M0.861209395,87.046875 L25.2245022,80.6910618 M35.2456146,74.9997405 C37.4525198,73.0335109 39.1549642,70.7585667 40.3529478,68.174908 C43.2229212,61.9853142 43.2229212,53.9781692 40.3529478,44.1534729 L27.515625,0"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeWidth={tracksWidth}
			strokeLinecap="round"/>

		<TrackArrow
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			transform="translate(36.794821, 73.416246) rotate(-410.000000) translate(-36.794821, -73.416246) "
			points="40.7948214 81.4162455 32.7948214 73.4162455 40.7948214 65.4162455"/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'TrackKBlue')}
			coords="26.000000, 25.000000"
			text="K"
			size="small"
			textCoordsX="8.5"
			textCoordsY="17.3"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>

);

TrackKBlue.propTypes = trackPropTypes;

export default TrackKBlue;
